// extracted by mini-css-extract-plugin
export default {"icon":"cvvPopup_icon__TsEpj","details":"cvvPopup_details__fSzHO","submit":"cvvPopup_submit__nAuKP","footer":"cvvPopup_footer__bZpf9","error":"cvvPopup_error__a3g9F"};